import { SidebarItem } from "@coachhubio/nova-sidebar";
import { useTranslation } from "react-i18next";

import { StyledLink } from "../LookerDashboardSideBar.styles";
import { AISectionIds, AISectionProps } from "../utils/dashboardSideBar";

export const AIMenu = ({ currentSectionIndex }: { currentSectionIndex: string }) => {
  const { t } = useTranslation('Dashboard');
  return (
    <>
      <StyledLink
        href={AISectionProps[AISectionIds.AI_ENGAGEMENT]['href']}
        data-testid={AISectionIds.AI_ENGAGEMENT}
        key={AISectionIds.AI_ENGAGEMENT}
      >
        <SidebarItem
          active={AISectionIds.AI_ENGAGEMENT === currentSectionIndex}
          Icon={AISectionProps[AISectionIds.AI_ENGAGEMENT]['icon']}
        >
          {t(`section.ai-engagement`)}
        </SidebarItem>
      </StyledLink>
      <StyledLink
        href={AISectionProps[AISectionIds.AI_SATISFACTION]['href']}
        data-testid={AISectionIds.AI_SATISFACTION}
        key={AISectionIds.AI_SATISFACTION}
      >
        <SidebarItem
          active={AISectionIds.AI_SATISFACTION === currentSectionIndex}
          Icon={AISectionProps[AISectionIds.AI_SATISFACTION]['icon']}
        >
          {t(`section.ai-satisfaction`)}
        </SidebarItem>
      </StyledLink>
      <StyledLink
        href={AISectionProps[AISectionIds.AI_IMPACT]['href']}
        data-testid={AISectionIds.AI_IMPACT}
        key={AISectionIds.AI_IMPACT}
      >
        <SidebarItem
          active={AISectionIds.AI_IMPACT === currentSectionIndex}
          Icon={AISectionProps[AISectionIds.AI_IMPACT]['icon']}
        >
          {t(`section.ai-impact`)}
        </SidebarItem>
      </StyledLink>
    </>
  );
};
